jQuery(document).ready(function($) {

  // Slick Slider
  $('.cit-slick').slick({
		infinite: true,
		//arrows: true,
		//dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 6000,
		speed: 500,
		fade: true,
		cssEase: 'linear'
	});
  
  $('.mb-carousel-basic').slick({
    infinite: true,
    arrows: true,
	dots: true,
    slidesToShow: 1,
	slidesToScroll: 1,
	adaptiveHeight: true,
  	autoplay: true,
  	autoplaySpeed: 6000,
  });

  // Activate animations
  wow = new WOW({
    boxClass:     'wow',      // default
	animateClass: 'animated', // default
	offset:       0,          // default
	mobile:       true,       // default
	live:         true        // default
  })
  wow.init();
  
});